export const RUN_OBSERVABILITY_STAT_TILE_TEST_ID = "run-observability-stat-tile";
